module.exports = __webpack_public_path__ + "static/media/welcome-cloud-large.e82d3cc8.svg";